import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Container, Button, Image } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Images from "../../images/index";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import "../Response.css";

function EminenceGrp4Response() {
  const user = useSelector((state) => state.authentication.user);

  const [response, setResponses] = useState([]);
  const responseId = useParams();

  const getResponse = async () => {
    const res = await axios.get(
      `/api/forms/ventures/eminence-4-group/${responseId.id}`,
    );
    console.log(res.data);
    setResponses(res.data);
  };

  useEffect(() => {
    getResponse();
  }, []);

  const printDocument = () => {
    var divContents = document.getElementById("mainForm").innerHTML;
    var a = window.open("", "blank", "height=1123,width=800,scrollbars=yes,");
    a.document.write("<html>");
    a.document.write("<link>");
    a.document
      .write(`<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous"
    />`);
    a.document.write("</link>");

    a.document.write(`
    <title>Eminence Group Q5</title>
    `);
    a.document.write("<style>");
    a.document.write(`@media print {
      @page {
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }

    html {
      overflow-y: auto;
    }

    .fResponseBody {
      padding: 20px 20px;
      width: 800px;
      min-height: 1123px;
      background: #fff;
    }

    .page{
      page-break-after: always;
    }

    .centerFormat {
      width: 800px;
      margin: 0 auto;
    }

    .section2, .section3{
      margin-top: 30px;
    }

    .section4{
      margin-top: 20px;
    }

    .bordered-col{
      padding: 3px 10px;
      border: 1px solid #000;
    }

    .bordered-mid-col{
      padding: 3px 10px;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
    }

    .bordered-row{
      padding: 3px 0;
      border: 1px solid #000;
    }

    .bordered-mid-row{
      padding: 2px 0px;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
    }

    .bordered-row-b{
      padding: 2px 0;
      border: 1px solid #000;
      height: 30px;
    }

    .bordered-col-b{
      padding: 2px 5px;
      border: 1px solid #000;
      height: 30px;
    }

    .blueBG {
      background: rgb(185, 213, 250);
      border-radius: 8px;
      height: 20px;
      margin-bottom: 5px;
    }

    .bannerText {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .bannerText h1 {
      font-family: "Arial-Bold";
      font-size: 24px;
      font-weight: 600;
    }

    .bannerText h2 {
      font-family: "Arial-Bold";
      font-size: 20px;
      font-weight: 400;
    }

    .toptext {
      margin: 20px 0;
    }

    .logoImage {
      height: 80px;
      margin: 10px;
    }

    .bannerYellow {
      background: #face1d;
      border-top: 12px solid #3e4095;
      margin-bottom: 30px;
      -webkit-print-color-adjust: exact;
    }

    .Tbox {
      border: 1px solid rgb(0, 0, 0);
      padding: 11px 15px;
      margin: 20px 0;
    }

    .Tsingle-enter {
      font-family: "Arial";
      font-size: 12px;
      margin-bottom: 0;
    }

    .Tsingle-enter-label {
      font-family: "Arial";
      font-size: 12px;
      margin-top: 3px;
      margin-bottom: 0;
      line-height: 97%;
    }

    .Tdouble-enter {
      font-family: "Arial";
      margin-top: 11px;
      font-size: 12px;
      margin-bottom: 0;
    }

    .Tsign-enter {
      font-family: "Arial";
      margin-top: 30px;
      font-size: 12px;
      margin-bottom: 0;
    }

    .Hdouble-enter {
      font-family: "Arial";
      margin: 16px auto;
      font-size: 16px;
      color: #000;
      font-weight: 600;
    }

    .H2double-enter {
      font-family: "Arial";
      margin: 0;
      margin-top: 16px;
      font-size: 16px;
      color: #000;
      font-weight: 600;
    }

    .H3double-enter {
      font-family: "Arial";
      margin: 0;
      margin-top: 14px;
      font-size: 14px;
      color: #000;
      font-weight: 600;
    }

    .H3single-enter {
      font-family: "Arial";
      margin: 0;
      font-size: 14px;
      color: #000;
      font-weight: 600;
    }

    .H4single-enter {
      font-family: "Arial";
      margin: 0;
      font-size: 12px;
      color: #000;
      font-weight: 600;
    }

    .Lsingle-enter li {
      font-family: "Arial";
      font-size: 12px;
      margin-bottom: 0;
    }

    .Ldouble-enter li {
      font-family: "Arial";
      font-size: 12px;
      margin-bottom: 0;
      margin-top: 12px
    }

    .response {
      font-family: "Arial";
      font-size: 12px;
      font-weight: 600;
      text-decoration: underline;
    }

    .Tsingle {
      font-family: "Arial";
      font-size: 16px;
      text-decoration: none;
      font-weight: 400;
      color: rgb(0, 0, 0);
      margin-bottom: 8px;
    }

    .Tdouble {
      font-family: "Arial";
      font-size: 16px;
      text-decoration: none;
      font-weight: 400;
      color: rgb(0, 0, 0);
      margin-bottom: 24px;
    }`);
    a.document.write("</style>");
    a.document.write("<body>");
    a.document.write(divContents);
    a.document.write("</body></html>");
    a.document.close();
    setTimeout(function() {
      a.print();
    }, 1000);
  };

  const mainFormRef = useRef(null);

  return (
    <div>
      <Row style={{ marginBottom: "1em", marginTop: "1em" }}>
        <Col
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            onClick={() => printDocument()}
            style={{ margin: "0 5px", marginBottom: "20px" }}
          >
            Download Form
          </Button>

          <h2>Eminence 4 (Groups)</h2>
        </Col>
      </Row>

      <div id="mainForm" ref={mainFormRef} className="centerFormat">
        <div className="fResponseBody">
          <div className="page">
            <div className="bannerYellow">
              <Row className="T-Banner">
                <Col xs={1}>
                  <img
                    src={Images.LogoB}
                    className="logoImage"
                    alt="jsgBanner"
                  ></img>
                </Col>
                <Col xs={11} className="bannerText text-center">
                  <h1
                    style={{
                      margin: "0",
                    }}
                  >
                    JSG INT. FEDERATION - SOUTH REGION
                  </h1>

                  <p
                    className="Tsingle-enter"
                    style={{
                      padding: "0 20px",
                      fontSize: "18px",
                      margin: "0",
                      fontWeight: "600",
                    }}
                  >
                    Eminence 4 (Groups)
                  </p>
                </Col>
              </Row>
            </div>
            <Row>
              <h6
                style={{
                  fontWeight: "700",
                  textTransform: "capitalize",
                  marginBottom: "5px",
                }}
              >
                Region - South
              </h6>
              <h6
                style={{
                  fontWeight: "700",
                  textTransform: "capitalize",
                  marginBottom: "10px",
                }}
              >
                Group - {response.grpName}
              </h6>
            </Row>
            <Row>
              <Col style={{ textAlign: "center" }}>
                <h3 className="H3single-enter">Respondant's name</h3>
                <p className="Tsingle-enter">{response.name}</p>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <h3 className="H3single-enter">Group President Name</h3>
                <p className="Tsingle-enter">{response.grpPresName}</p>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <h3 className="H3single-enter">Group President Number</h3>
                <p className="Tsingle-enter">{response.presNum}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <h3 className="H3single-enter" style={{ marginTop: "10px" }}>
                  Form A submitted in time
                </h3>
                <p className="Tsingle-enter">{response.formA}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3 className="H3single-enter" style={{ marginTop: "10px" }}>
                  Dues paid in time
                </h3>
                <p className="Tsingle-enter">{response.dues}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <h3 className="H3single-enter" style={{ marginTop: "10px" }}>
                  Form B submitted in time
                </h3>
                <p className="Tsingle-enter">{response.formB}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <h3 className="H3single-enter" style={{ marginTop: "10px" }}>
                  Eminence forms filled
                </h3>
                <p className="Tsingle-enter">{response.eminence}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <h3 className="H3single-enter" style={{ marginTop: "10px" }}>
                  Mangalyatra reports submitted
                </h3>
                <p className="Tsingle-enter">{response.mangalyatra}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <h3 className="H3single-enter" style={{ marginTop: "10px" }}>
                  Events completed from October till 20th December
                </h3>
                <p className="Tsingle-enter">{response.numEvents}</p>
              </Col>
            </Row>

            <Row style={{ marginTop: "20px" }}>
              {(() => {
                if (
                  response.picEvent1 !== null ||
                  response.subEvent1 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 1</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants1}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants1}
                      </h4>
                      <h4 className="H4single-enter">{response.type1} </h4>
                      <h4 className="H4single-enter">{response.subEvent1}</h4>
                      <Image
                        src={response.picEvent1}
                        alt={response.subEvent1}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent2 !== null ||
                  response.subEvent2 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 2</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants2}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants2}
                      </h4>
                      <h4 className="H4single-enter">{response.type2} </h4>
                      <h4 className="H4single-enter">{response.subEvent2}</h4>
                      <Image
                        src={response.picEvent2}
                        alt={response.subEvent2}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent3 !== null ||
                  response.subEvent3 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 3</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants3}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants3}
                      </h4>
                      <h4 className="H4single-enter">{response.type3} </h4>
                      <h4 className="H4single-enter">{response.subEvent3}</h4>
                      <Image
                        src={response.picEvent3}
                        alt={response.subEvent3}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent4 !== null ||
                  response.subEvent4 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 4</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants4}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants4}
                      </h4>
                      <h4 className="H4single-enter">{response.type4} </h4>
                      <h4 className="H4single-enter">{response.subEvent4}</h4>
                      <Image
                        src={response.picEvent4}
                        alt={response.subEvent4}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent5 !== null ||
                  response.subEvent5 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 5</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants5}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants5}
                      </h4>
                      <h4 className="H4single-enter">{response.type5} </h4>
                      <h4 className="H4single-enter">{response.subEvent5}</h4>
                      <Image
                        src={response.picEvent5}
                        alt={response.subEvent5}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent6 !== null ||
                  response.subEvent6 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 6</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants6}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants6}
                      </h4>
                      <h4 className="H4single-enter">{response.type6} </h4>
                      <h4 className="H4single-enter">{response.subEvent6}</h4>
                      <Image
                        src={response.picEvent6}
                        alt={response.subEvent6}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent7 !== null ||
                  response.subEvent7 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 7</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants7}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants7}
                      </h4>
                      <h4 className="H4single-enter">{response.type7} </h4>
                      <h4 className="H4single-enter">{response.subEvent7}</h4>
                      <Image
                        src={response.picEvent7}
                        alt={response.subEvent7}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent8 !== null ||
                  response.subEvent8 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 8</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants8}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants8}
                      </h4>
                      <h4 className="H4single-enter">{response.type8} </h4>
                      <h4 className="H4single-enter">{response.subEvent8}</h4>
                      <Image
                        src={response.picEvent8}
                        alt={response.subEvent4}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent9 !== null ||
                  response.subEvent9 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 9</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants9}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants9}
                      </h4>
                      <h4 className="H4single-enter">{response.type9} </h4>
                      <h4 className="H4single-enter">{response.subEvent9}</h4>
                      <Image
                        src={response.picEvent9}
                        alt={response.subEvent9}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                if (
                  response.picEvent10 !== null ||
                  response.subEvent10 !== null
                ) {
                  return (
                    <Col
                      xs={4}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <h3 className="H3single-enter">Event 10</h3>
                      <h4 className="H4single-enter">
                        Total Participants - {response.participants10}
                      </h4>
                      <h4 className="H4single-enter">
                        Couple Participants - {response.coupleparticipants10}
                      </h4>
                      <h4 className="H4single-enter">{response.type10} </h4>
                      <h4 className="H4single-enter">{response.subEvent10}</h4>
                      <Image
                        src={response.picEvent10}
                        alt={response.subEvent10}
                        fluid
                      />
                    </Col>
                  );
                }
              })()}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EminenceGrp4Response;
